<template>
  <div ref="chart" class="screen-chart" />
</template>

<script>
import * as echarts from 'echarts'
import { debounce } from '@/utils'

export default {
  name: 'ScreenChart',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.update()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.chart = echarts.init(this.$refs.chart)
      this.update()
      this.__onResize = debounce(() => {
        if (this.chart) this.chart.resize()
      }, 120)
      window.addEventListener('resize', this.__onResize)
      if (typeof ResizeObserver !== 'undefined' && this.$refs.chart) {
        this.__ro = new ResizeObserver(this.__onResize)
        this.__ro.observe(this.$refs.chart)
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.__onResize)
    if (this.__ro) this.__ro.disconnect()
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    update() {
      if (!this.chart || !this.options) return
      this.chart.setOption(this.options, true)
      this.chart.resize()
    },
    resize() {
      if (this.chart) this.chart.resize()
    }
  }
}
</script>

<style scoped>
.screen-chart {
  width: 100%;
  height: 100%;
}
</style>
